const calculateCountdown = (endDate: Date | string) => {
  if (!endDate) return 0;

  const now = new Date().getTime();
  const endTime = new Date(endDate).getTime();

  const diffMs = endTime - now;
  const diffSeconds = Math.floor(diffMs / 1000);

  return diffSeconds > 0 ? diffSeconds : 0;
};

const isClientSide = () => import.meta.client;
const isServerSide = () => import.meta.server;

const isNil = (value: unknown) => value === null || value === undefined;

export { calculateCountdown, isClientSide, isServerSide, isNil };
